import Record from "./base"

export class Member extends Record {
  constructor(...args) {
    super(...args)
    // const [model, props] = args
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/members.js